module.exports = __webpack_public_path__ + "static/media/1.fe1c1c4a.jpg";